let currentIndex = 0;
const scroller = document.querySelector(".scroller");
const wrapper = scroller.querySelector(".related_product_wrapper");
const children = wrapper.children;
const prevButton = document.querySelector(".swiper-button-prev");

// Get the width of a child (assumes all children have the same width)
function getChildWidth() {
  return children[0].offsetWidth;
}

function setButtonState(button, isDisabled) {
  if (!button) return;
  button.style.opacity = isDisabled ? "0.5" : "1";
  button.style.cursor = isDisabled ? "not-allowed" : "pointer";
}

function scrollProducts(direction) {
  const childWidth = getChildWidth();
  // Calculate max index so we don't scroll past the last item
  const maxIndex = children.length - Math.floor(scroller.clientWidth / childWidth);

  if (direction === "prev") {
    currentIndex = Math.max(currentIndex - 1, 0);
  } else if (direction === "next") {
    currentIndex = Math.min(currentIndex + 1, maxIndex);
  }

  const scrollTo = currentIndex * childWidth;

  scroller.scrollTo({
    top: 0,
    left: scrollTo,
    behavior: "smooth",
  });

  updateButtonState(currentIndex);
}

function updateButtonState(index) {
  const childWidth = getChildWidth();
  const maxIndex = Math.max(0, children.length - Math.floor(scroller.clientWidth / childWidth));

  setButtonState(prevButton, index <= 0);

  const nextButton = document.querySelector(".swiper-button-next");
  setButtonState(nextButton, index >= maxIndex);
}

// Optional: Update index on manual scroll (snaps to nearest child)
scroller.addEventListener("scroll", function () {
  const childWidth = getChildWidth();
  currentIndex = Math.round(this.scrollLeft / childWidth);
  updateButtonState(currentIndex);
});

// Initial state
updateButtonState(0);

if (!customElements.get('sparklayer-pricing')) {
  class SparklayerPricing extends HTMLElement {
    constructor() {
      super();
      this.id = parseInt(this.getAttribute('product-id'));
      this.string = this.getAttribute('data-string'); 
      this.format = this.getAttribute('data-format'); 
      this.vatRate = parseFloat(this.getAttribute('vat-rate')) || 0; 
    }

    connectedCallback() {
      // Wrapped data fetch in a timeout to allow page to fully load.
      setTimeout(() => {
        if (window.spark) {
          this.getData();
        }
      }, 500);
    }

    getData() {
      window.spark.getProduct(this.id).then((response) => {

        if (!response?.variants?.length || !response.variants[0].price?.net) {
          return;
        }

        const targetVariant = response.variants[0];
        const priceData = targetVariant.price;
        const rawPrice = priceData.net;

        const priceInCents = rawPrice * 100;
        const taxMultiplier = this.vatRate > 0 ? (1 + this.vatRate / 100) : 1;
        const finalPriceInCents = priceInCents * taxMultiplier;
        const formattedPrice = this.formatMoney(finalPriceInCents, this.format);

        if (this.string && this.string.includes('[[price]]')) {
          this.innerText = this.string.replace('[[price]]', formattedPrice);
        } else {
          this.innerText = formattedPrice;
        }
      }).catch((error) => {
        return;
      });
    }

    formatMoney(cents, format) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || '{{amount}}'; 

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number == null) return '0';

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      const match = formatString.match(placeholderRegex);
      if (!match) {
        return formatWithDelimiters(cents, 2);
      }

      switch (match[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return formatString.replace(placeholderRegex, value);
    }
  }

  customElements.define('sparklayer-pricing', SparklayerPricing);
}